/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  cityDataReducerCreator.js
 */

import { ON_BROWSER } from '@zcode/nr/es/shared/env'
import { payloadKeyReducer } from '@zcode/reducers'
import type { PriceChartData } from '@zcode/state-type'
import { type NarrowedAction, handleActions } from 'redux-actions'
import type {
  CITY_NAME_CHANGED,
  CLEAR_CITY_NAME,
} from '../../../currentSearch/modules/location/constants'
import type * as detailConstants from '../../constants/detail'
import type * as localeConstants from '../../constants/locale'
import type { ActionTypes } from '../types'

type ActionConstants =
  | {
      clearData: typeof localeConstants.CLEAR_PRICE_CHART_DATA
      clearCityName: typeof CLEAR_CITY_NAME
      cityNameChanged: typeof CITY_NAME_CHANGED
      setData: typeof localeConstants.SET_CITY_PRICE_CHART_DATA
    }
  | {
      clearData: typeof detailConstants.CLEAR_PRICE_CHART_DATA
      clearCityName: typeof CLEAR_CITY_NAME
      cityNameChanged: typeof CITY_NAME_CHANGED
      setData: typeof detailConstants.SET_CITY_PRICE_CHART_DATA
    }

export const cityDataReducerCreator = ({
  clearData,
  clearCityName,
  cityNameChanged,
  setData,
}: ActionConstants) => {
  return handleActions<PriceChartData, ActionTypes>(
    {
      [clearData]: () => [],
      ...(ON_BROWSER
        ? {
            [clearCityName]: () => [],
            [cityNameChanged]: () => [],
          }
        : undefined),
      [setData]: payloadKeyReducer<
        PriceChartData,
        'priceChartData',
        NarrowedAction<ActionTypes, typeof setData>['payload']
      >('priceChartData'),
    },
    []
  )
}
